import { z } from 'zod';

/** Templates sendable via Messaging API / auto rules today. */
export const orderAvailableMessagesSchema = z.enum(['order_waybill', 'order_driver_assign']);
export type OrderAvailableMessages = z.infer<typeof orderAvailableMessagesSchema>;

/** Message delivery channels (WhatsApp now; email later). */
export const messageChannelSchema = z.enum(['whatsapp', 'email']);
export type MessageChannel = z.infer<typeof messageChannelSchema>;
